import { motion } from "framer-motion";
import { Clock, ShieldCheck, MapPinned, Sparkles } from "lucide-react";

const items = [
  { icon: Clock, title: "Quick Response", sub: "24/7 Client Support" },
  { icon: ShieldCheck, title: "Trusted Since 2011", sub: "15+ Years of Trust" },
  { icon: MapPinned, title: "Pan India Reach", sub: "Destination Weddings" },
  { icon: Sparkles, title: "One-Stop Solution", sub: "Venue to Vidai" },
];

export default function TrustStrip() {
  return (
    <section data-testid="trust-strip" className="relative z-20 -mt-16 md:-mt-20 px-6">
      <div className="max-w-[1300px] mx-auto bg-heirloom-bone rounded-2xl shadow-[0_20px_60px_-25px_rgba(0,0,0,0.35)] border border-heirloom-line grid grid-cols-2 md:grid-cols-4">
        {items.map((it, i) => (
          <motion.div
            key={it.title}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className={`flex items-center gap-4 p-6 md:p-8 ${i !== 0 ? "md:border-l border-heirloom-line" : ""} ${i >= 2 ? "border-t md:border-t-0 border-heirloom-line" : ""} ${i === 1 ? "border-l md:border-l" : ""}`}
          >
            <span className="shrink-0 h-12 w-12 rounded-full bg-heirloom-maroon/10 text-heirloom-maroon flex items-center justify-center">
              <it.icon size={22} />
            </span>
            <div>
              <div className="font-display text-lg text-heirloom-obsidian leading-tight">{it.title}</div>
              <div className="text-xs text-heirloom-obsidian/55 mt-0.5">{it.sub}</div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
